import { Dispatch, SetStateAction } from "react";

/**
 * Handlers de latitude e longitude do campo location da entidade
 * 
 * @param setEntity - O setter de estado da entidade que tem o campo location
 * @returns Os dois handlers, prontos para o onChange dos campos
 */
export const useCoordinates = <T,>(setEntity: Dispatch<SetStateAction<T>>) => {
  const setCoordinate = (index: 0 | 1, value: unknown) => {
    setEntity((curr: any) => {
      const coordinates = [...(curr?.location?.coordinates ?? [0, 0])];
      coordinates[index] = parseFloat((value || 0) as string);
      return { ...curr, location: { ...(curr?.location ?? { type: "Point" }), coordinates } };
    });
  };

  return {
    handleLat: (value: unknown) => setCoordinate(1, value),
    handleLong: (value: unknown) => setCoordinate(0, value),
  };
};
